import {store} from "../../app/store";
import {MarkerProps} from "../../components/pin/schedule-pin/ScheduleCreatePin";
import {Delivery} from "../../types/delivery/delivery";
import {DeliveryGroupType} from "../../types/schedule/delivery-group-type";
import {timeFormat} from "../date/date-format";
import {getDeliveriesInGroupByPreview} from "../delivery/delivery";

function areAllAliasSame(
    deliveries: Delivery[],
    deliveryType: DeliveryGroupType,
): boolean {
    if (deliveries.length === 0) {
        return true;
    }

    const firstDelivery = deliveries[0];

    const checkName = deliveryType == DeliveryGroupType.PickUp ? firstDelivery.pickUpWorkPlace.alias : firstDelivery.dropOffWorkPlace.alias

    return deliveries.every(delivery => {
        if (deliveryType == DeliveryGroupType.PickUp) {
            return delivery.pickUpWorkPlace.alias === checkName
        } else {
            return delivery.dropOffWorkPlace.alias === checkName
        }
    });
}

export const getMarkerFormat = (
    deliveries: Delivery[],
    locationId: string,
    deliveryType: DeliveryGroupType
): MarkerProps => {
    const {preview} = store.getState().schedule;

    const deliveriesTimeLimited = deliveries.map((delivery) => {
        if (deliveryType === DeliveryGroupType.PickUp) {
            return timeFormat(delivery.pickUpAction.startTimeLimited);
        } else {
            return timeFormat(delivery.dropOffAction.startTimeLimited);
        }
    });

    let timeRange = "";
    // if (deliveriesTimeLimited.length === 1) {
    //     timeRange = deliveriesTimeLimited[0];
    // } else {
    //     deliveriesTimeLimited.sort();
    //     const lastDeliveriesTimeLimited = deliveriesTimeLimited.at(-1);
    //
    //     if (deliveriesTimeLimited[0] === lastDeliveriesTimeLimited) {
    //         timeRange = deliveriesTimeLimited[0];
    //     } else {
    //         timeRange = `${deliveriesTimeLimited[0]} ~ ${lastDeliveriesTimeLimited}`;
    //     }
    // }
    const totalDeliveries = deliveries.length;

    const deliveriesInGroup = getDeliveriesInGroupByPreview(preview);

    const checkedDeliveries = deliveries
        .map((delivery) => delivery.id)
        .filter((deliveryId) => {
            return deliveriesInGroup
                .map((delivery) => delivery.id)
                .includes(deliveryId);
        }).length;

    let index = 0;

    if (preview) {
        for (index; index < preview.length; index++) {
            if (preview[index].location.id?.includes(locationId)) {
                break;
            }
        }
    }

    let aliasLabel;
    let firstDelivery = deliveries[0];
    aliasLabel = deliveryType == DeliveryGroupType.PickUp
        ? (firstDelivery.pickUpWorkPlace.alias ?? firstDelivery.pickUpLocation.road)
        : (firstDelivery.dropOffWorkPlace.alias ?? firstDelivery.dropOffLocation.road);

    if (!areAllAliasSame(deliveries, deliveryType)) {
        aliasLabel += ` 외`
    }

    return {
        type: deliveryType,
        timeRange: timeRange,
        aliasLabel: aliasLabel,
        totalDeliveries: totalDeliveries,
        checkedDeliveries: checkedDeliveries,
        focus: !!checkedDeliveries,
        deliveryGroupOrder: index + 1,
    };
};
